import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import request from "@/service/invites";
import orgTreeModal from "@/components/Modal/select-org-tree-modal.vue";
export default {
  name: "EditorInviteModal",
  components: {
    orgTreeModal
  },
  data() {
    return {
      organizationTree: [],
      inviteForm: {
        validityType: 0,
        orgId: [],
        needApprove: "T",
        isInvalid: "F",
        inviteCode: null //邀请码
      },
      visiable: false,
      rules: {
        validityType: [{
          required: true,
          type: "number",
          message: $t("x7skfb7", "请选择有效期限"),
          trigger: "change"
        }]
      },
      orgList: []
    };
  },
  computed: {
    validityTypeList() {
      return [{
        label: $t("dzch7w4", "永久有效"),
        value: 4
      }, {
        label: $t("ixe2", "7天"),
        value: 0
      }, {
        label: $t("1j7p3", "15天"),
        value: 1
      }, {
        label: $t("1kks3", "30天"),
        value: 2
      }, {
        label: $t("1p0y3", "90天"),
        value: 3
      }];
    }
  },
  methods: {
    getData(data) {
      this.inviteForm.orgId = data.map(item => item.key);
      let res = this.$refs.orgTreeModalRef.getEntities(this.inviteForm.orgId, []);
      this.orgList = res;
    },
    changeDepartment() {
      let {
        orgId
      } = this.inviteForm;
      let res = this.$refs.orgTreeModalRef.getEntities(orgId, []);
      this.orgList = res;
      this.$refs.orgTreeModalRef.open(res);
    },
    getOrgDept() {
      if (this.$refs.orgTreeModalRef) {
        let {
          orgId
        } = this.inviteForm;
        let res = this.$refs.orgTreeModalRef.getEntities(orgId, []);
        this.orgList = res;
      }
    },
    cancel() {
      this.visiable = false;
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          let {
            validityType,
            orgId,
            needApprove,
            isInvalid,
            inviteCode
          } = this.inviteForm;
          let data = {
            validityType,
            orgId: orgId ? orgId.join(",") : "",
            needApprove,
            isInvalid,
            inviteCode
          };
          let {
            result
          } = await request.createInviteLink(data);
          if (result === 0) {
            this.$Message.success($t("ai8d7e4", "修改成功"));
          }
          this.$emit("update");
          this.visiable = false;
        }
      });
    },
    reset() {
      this.inviteForm = {
        validityType: 0,
        orgId: [],
        needApprove: "T",
        isInvalid: "F",
        inviteCode: null //邀请码
      };
    },
    open(data) {
      let {
        orgId
      } = data;
      this.inviteForm = {
        ...data,
        orgId: orgId.split(",")
      };
      this.visiable = true;
    },
    findPathByOrgTree(tree, targetId) {
      let path = [];
      if (!tree || tree.length === 0) return path;
      const findPath = (nodes, target) => {
        for (let node of nodes) {
          if (node.value === target) {
            path.unshift(node.value);
            return true;
          }
          if (node.children && node.children.length > 0) {
            if (findPath(node.children, target)) {
              path.unshift(node.value);
              return true;
            }
          }
        }
        return false;
      };
      findPath(tree, targetId);
      return path;
    },
    formateOrgTree(orgs) {
      if (!orgs) return [];
      return orgs.map(org => {
        let item = {
          value: org.orgId,
          label: org.name
        };
        if (org.children && org.children.length > 0) {
          item.children = this.formateOrgTree(org.children);
        }
        return item;
      });
    },
    async getOrganizationTree() {
      let res = await request.getOrganizationTreeTree();
      let {
        retVal: {
          department
        }
      } = res;
      this.organizationTree = this.formateOrgTree(department);
    }
  },
  mounted() {
    this.getOrganizationTree();
  },
  watch: {
    "inviteForm.orgId": {
      handler() {
        this.getOrgDept();
      },
      immediate: true
    }
  }
};